{
  "schema": {
    "TerrainType": {
      "category": "definition",
      "fields": [
        {
          "name": "R",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "G",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "B",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "R_checkerboard",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "G_checkerboard",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "B_checkerboard",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "flip",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "IDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "texture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sprite",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "buildSelectSprite",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "buildMarkerText",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "defaultSpriteOffset",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "heightMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "heightMod_actor",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sideSprite",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sideSpriteYMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "spriteXOffsetMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spriteYOffsetMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spriteXOffsetModulo",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "spriteYOffsetModulo",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "spriteXOffsetWaveApex",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "color",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "checkerboardColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "spriteType",
          "type": "SpriteType",
          "csType": "SpriteType"
        },
        {
          "name": "terrainGroup",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "treatAsSameGroup",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "terrainElement",
          "type": "Element",
          "csType": "Element"
        },
        {
          "name": "light",
          "type": "Light",
          "csType": "Light"
        },
        {
          "name": "blockLoE",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockLoS",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockLight",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockLightEdgeAdjust",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "moveCost",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "blockWalking",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockJumping",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canJumpOverFromAngle",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "canSwimIn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canFlyOver",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canTeleportOver",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "reflective",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showBackground",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "transparent",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "typeToDrawUnderThisTile",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "drawOffsetTileUnderThisTileX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "drawOffsetTileUnderThisTileY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "pR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "staticPalettes",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "pRi",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "pGi",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "pBi",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "depthMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "depthMod_typeUnder",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotation",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "reactionsCauseTerrainFX",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Light": {
      "category": "nested",
      "fields": [
        {
          "name": "alpha",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "red",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "green",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "blue",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "X",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "Y",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "texture",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "color",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "size",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "flicker",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "flip",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "offset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "ElementReaction": {
      "category": "nested",
      "fields": [
        {
          "name": "element",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "actorValues",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "newID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnItem",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "applyElement",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "action",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "damageMultiplier",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "healMultiplier",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "quantityMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "quantityMod_rand",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "quantitySetTo",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "fx",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "aiRatingMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiRatingModForHostilesOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "delayUntilCanReactAgain",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "actorValue",
          "type": "List<string>",
          "csType": "List<string>",
          "virtual": true
        }
      ],
      "supportsCloneFrom": false
    },
    "ActorValue": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "prefixIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "effectDescriptionExtraText",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "description",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bubbleIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minimum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maximum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "defaultValue",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "harmfulMagnitude",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "animationOnHarmful",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "affectsActors",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canAffectIncapped",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbers",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbersMagnitude",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbersSign",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbersIcon",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbersElements",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showDamageNumbersIconInTooltips",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "damageNumberColor_Positive",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "damageNumberColor_Negative",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "actorPaletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actorPaletteOverrideDuration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "elementReactionModifiesDuration",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canBeRemovedByNonspecificAVEffectRemoval",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "removedByNegativeMagnitude",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "activeEffects",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "recordInActorData",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showEvaluationInfo",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "allowDecimalValues",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "percentage",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "XPCostBase",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "XPCostIncrement",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "XPCostMultiplier",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "XPCostFloorToNearest",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxXPCost",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "AIValue",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "AIValueMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "castActionOnDurationEnd",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "executeActionOnDurationEnd",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "rankOrXPAV",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ActorValueEffect": {
      "category": "nested",
      "fields": [
        {
          "name": "actorValue",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "magnitude",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "duration",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "sourceAVAffecter",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "sourceType",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "iconText",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "formulaMod",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "durationIsWorldtimeDays",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showNoDescription",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "hideAllEffects",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "stacksWithSelf",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canBeRemovedByNonspecificAVEffectRemoval",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "critical",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ActorType": {
      "category": "definition",
      "fields": [
        {
          "name": "defaultSprite",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spriteDepthOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "previewSprite",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "baseSpriteExtraHeight",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "baseSpriteExtraWidth",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "adjustSpriteX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "adjustSpriteY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "adjustStatusEffectsX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "statusEffectAdjust",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "statusEffectAboveAdjust",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "offsetFromRollpinYLimit",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ignoreRollpinScaling",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysDrawActor",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "lockFacingRotTo",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "noFacingRotRows",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "facingRotIsActualRot",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "include45DegStance",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysRoundFacingTo90",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "restrictedTurningInCombat",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "showAlertIcon",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "depthMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "description",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "randomNames",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "playerUsable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "playerUnlockable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "weight",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "powerLevelMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "powerLevelMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "XPMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "XPDecayPerKillMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bodyStructure",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "multiPartCollisions",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "extendTailWhenSpawnedOnlyIfAestheticTail",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "extraBodyHurtboxes",
          "type": "List<Vector2>",
          "csType": "List<Vector2>"
        },
        {
          "name": "extraBodyHurtboxes_protected",
          "type": "List<bool>",
          "csType": "List<bool>"
        },
        {
          "name": "disappearOnDeath",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "disappearOnDeath_dropItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "unrevivable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rotatedCorpse",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "directionless",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawShadow",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cannotStartCombat",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canUseItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fearless",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSeeStats",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSeeStatsTravelMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSeeNameTravelMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSeeActEval",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSpawnWithClass",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "randomSkinPaletteOnSpawn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "tailPartsRespectGrid",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "dieWhenCrewless",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "bigCollisions",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "humanoid",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "tameable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "movementType",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "movementSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "light",
          "type": "Light",
          "csType": "Light"
        },
        {
          "name": "constantAvEffects",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "ruinAvEffects",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "idleAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "walkAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "jumpAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "climbAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "painAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dodgeAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "blockAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "chargeAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "castAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spellcastAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "swingAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sleepAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "stunAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "frozenAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "drownAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "criticalAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "deadAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "specialAnim_prefix",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "fxSpeech",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "fxOnPhysicalHPDmg",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "fxOnOtherHPDmg",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "fxOnDeath",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnFX_frame4",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnFX_frame100",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "unarmedAction",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "unarmedPower",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "innateActions",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "skinPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "clothPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "armorPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "defaultFaction",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "defaultCombatTeam",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "defaultHostile",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "aggressiveness",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bravery",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "honor",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "intelligence",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "defaultAI",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "canBeMounted",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "mountedForceAnim",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "mountedAdjustYMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "mountedAdjustDepthMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "mountedAdjustDepthMod_fRot90",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "mountedAdjustDepthMod_fRot_0_180",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "distBetweenTailParts",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "nonRotatingTailPartsUseFacingRotFlip",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "journalID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "inventorySize",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "defaultValues",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "valuesDictOverrides",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "defaultBodyPartSprites",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "bodyPartSprites",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "skinPalettes",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "defaultSupportAbilities",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "ruinModeSupportAbility",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "partSpritesThatTakePriorityOverClass",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "detectionAoE",
          "type": "AreaOfEffect",
          "csType": "AreaOfEffect"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "defaultDialogNode",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_speechFont",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_confident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_uneasy_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_uneasy_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryCombat_scared_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_confident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_uneasy_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_uneasy_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_scared_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryPeace_scared_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_overconfident_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_confident_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_uneasy_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialog_tryBribe_scared_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_confident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_uneasy_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_uneasy_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryCombat_scared_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_confident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_uneasy_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_uneasy_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_scared_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryPeace_scared_flee",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_overconfident_fight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_overconfident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_overconfident_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_confident_peace",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_confident_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_uneasy_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "anim_tryBribe_scared_bribe",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "iAmABoat",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "minimumCrew",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "value",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "shipTileWidth",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "shipOffsetYMainMenu",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "boardingAnimationShake",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "AreaOfEffect": {
      "category": "nested",
      "fields": [
        {
          "name": "shape",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "minRange",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxRange",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxRangeBonus",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "needsLoS",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "needsLoE",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "faction",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "canBypassElementRestriction",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "restrictedToTerrainElement",
          "type": "Element",
          "csType": "Element"
        },
        {
          "name": "horizMax",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxTurningRadius",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "turnPerMove",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aoeCasterAsOrigin",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "airborne",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "arc",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSwim",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "swimOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canFloatMidair",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "darkOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSelectActors",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSelectAllies",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSelectEnemies",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockedByAllies",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockedByEnemies",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canSelectStackedActors",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "teleporting",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "bypassAll",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "occupyAll",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreMovementCost",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreWind",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "maxMoveCostOccupiable",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "furthestPossibleOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "maxRangeAddDistanceFromCaster",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreCannotTarget",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "forcedRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "coneAngle",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "coneAngle_exclude1",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "coneAngle_exclude1_offset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "coneAngle_exclude2",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "coneAngle_exclude2_offset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "AoEPreset",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ItemType": {
      "category": "definition",
      "fields": [
        {
          "name": "itemCategory",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "special",
          "type": "HashSet<specialProperty>",
          "csType": "HashSet<specialProperty>"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "description",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "texture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "textureIDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sprite",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "spriteWhenHeld",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "IDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "combineID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "power",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "timer",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "depthMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "action",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "effects",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "effects_inWeapon",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "effects_inArmor",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "spawnFX",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "drawSprite",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "element",
          "type": "Element",
          "csType": "Element"
        },
        {
          "name": "weight",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "volume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "value",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "throwDamageMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "stackable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockLoE",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockLoS",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockWalking",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "blockJumping",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "light",
          "type": "List<Light>",
          "csType": "List<Light>"
        },
        {
          "name": "combineWith",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "toMake",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "consumeOnCombine",
          "type": "List<bool>",
          "csType": "List<bool>"
        },
        {
          "name": "requiredForCombining",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combineSound",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "cantFitInTileWith",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "journalID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "reactions_inWeapon",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "reactions_inArmor",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "invisible",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreDarkness",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "spriteScaleMult",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "alpha",
          "type": "byte",
          "csType": "byte"
        },
        {
          "name": "inheritTerrainPaletteR",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "inheritTerrainPaletteG",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "inheritTerrainPaletteB",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "roof",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "roofFaded",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "invisibleUnderRoofs",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fullTileRoof",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "itemsOnSameTileAreRaised",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "actorsOnSameTileAreRaised",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "raiseItemsDepth",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "raiseTileDepth",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "raiseItemsDepthMax",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ignoreBeingRaised",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreHeight",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "shopTile",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "defaultQuantity",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "defaultQuantity_rand",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Animation": {
      "category": "definition",
      "fields": [
        {
          "name": "attackKeyframe",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "bodyPartKeyframes",
          "type": "Dictionary<string, List<Keyframe>>",
          "csType": "Dictionary<string, List<Keyframe>>"
        },
        {
          "name": "keyframes",
          "type": "List<Keyframe>",
          "csType": "List<Keyframe>"
        },
        {
          "name": "duration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "speedMod_rand",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "applyFrameToAllParts",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "flicker",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawShadow",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "durationUntilAttackKeyframe",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "durationUntilAfterAttackKeyframe",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "flipArms",
          "type": "boolean",
          "csType": "bool",
          "virtual": true,
          "source": "DataManager"
        }
      ],
      "supportsCloneFrom": true
    },
    "Keyframe": {
      "category": "nested",
      "fields": [
        {
          "name": "frame",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "offset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "directionalOffset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "targetOffsetMult",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "jostleMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "facingRotOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "facingRotOverride",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rotOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "endTime",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "canStopHere",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "depthMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "fx",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "flip",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "retractIntoTail",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "retractTail",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "sheatheWeapon",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFromIndex",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "source": "DataManager"
        },
        {
          "name": "bodyPart",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager"
        },
        {
          "name": "replaceIndex",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "source": "DataManager"
        }
      ],
      "supportsCloneFrom": true
    },
    "Item": {
      "category": "instance",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "q",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "quantity",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "r",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "rot",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "oX",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "oY",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "bu",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "buried",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "br",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "timer",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "specialX",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "specialY",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "IDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "movement",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "offset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "broken",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "specialInfoTC",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "container",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "cantReactAgainTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "highlight",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "index_temp",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "containedIn",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "cSlot",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "containerID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "x",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "source": "DataManager"
        },
        {
          "name": "y",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "source": "DataManager"
        }
      ],
      "supportsCloneFrom": true
    },
    "JournalEntry": {
      "category": "definition",
      "fields": [
        {
          "name": "category",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "title",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "text",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "halfPage",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rarity",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "rewardMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "DialogNode": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "nextNodeID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "nextNodeID_fReq",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "speakerOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "portraitIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "portraitIconFrames",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "dialogFX",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "statements",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "animations",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "dialogOptions",
          "type": "List<DialogOption>",
          "csType": "List<DialogOption>"
        },
        {
          "name": "specialEffect",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "DialogOption": {
      "category": "nested",
      "fields": [
        {
          "name": "text",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltip",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "animation",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "color",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "formulaReq",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "nodeToConnectTo",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "glyph",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "includeSymbol",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "newLineOfOptions",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "bottomOption",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "escOption",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "specialEffect",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "specialNumValue",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "fReq",
          "type": "List<Formula>",
          "csType": "List<Formula>",
          "virtual": true
        },
        {
          "name": "special",
          "type": "List<string>",
          "csType": "List<string>",
          "virtual": true
        }
      ],
      "supportsCloneFrom": false
    },
    "DialogNodeOverride": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialogNodeID_toOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "priority",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "completeOverride",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overrideSpecialEffects",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "specialEffect",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "nextNodeID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "nextNodeID_fReq",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "speakerOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "portraitIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "portraitIconFrames",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "dialogFX",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "statements",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "animations",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "dialogOptions",
          "type": "List<DialogOption>",
          "csType": "List<DialogOption>"
        }
      ],
      "supportsCloneFrom": false
    },
    "Actor": {
      "category": "instance",
      "fields": [
        {
          "name": "statusEffectAnimFrames",
          "type": "const int",
          "csType": "const int"
        },
        {
          "name": "statusEffectSlowAnimFrames",
          "type": "const int",
          "csType": "const int"
        },
        {
          "name": "showHPTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sprite",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "skinPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "clothPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "armorPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "unarmoredPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "controllable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useAIevenWhenControllable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "incapacitated",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canAttractAttention",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "playerCanOpenInv",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "enabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fearless",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "unkillable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canManipCorpse",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canApplyDifficultyMods",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "male",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "givesXP",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canDespawn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alreadyKOdOnce",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alreadyLostMaxHPThisCombat",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canEditAppearance",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canLootCorpse",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canControlFullyIfControllable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "actualRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "favoredHand",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "dialogNodeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "statementPrefix",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "movementType",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "movementSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "faction",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "factionBoss",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "combatTeam",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combatMusicOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "idleAnimOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "animator",
          "type": "Animator",
          "csType": "Animator"
        },
        {
          "name": "dontInterruptAnimationWithAnimateIdle_timer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ai_lua",
          "type": "LuaRunner",
          "csType": "LuaRunner"
        },
        {
          "name": "aiVarX",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiVarY",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiVarX2",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiVarY2",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "turnsSpentUnableToMove",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "_aiTarget",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "aggressiveness",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bravery",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "honor",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "intelligence",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiRating_bonusToNotMoving",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiRating_priorityMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ai_extraTime",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "actorTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actorClass",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "secondaryClass",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actorClass3",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actorClass4",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "position",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "offset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "movementInputs",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "movement",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "pform_veloc",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "destination",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "state",
          "type": "ActorState",
          "csType": "ActorState"
        },
        {
          "name": "movementAoE",
          "type": "AreaOfEffect",
          "csType": "AreaOfEffect"
        },
        {
          "name": "inventory",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "gateItems",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "numRanksBought",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "chosenAbilityOfEachClass",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "activeEffects",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "damageTaken",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "timesKOd",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "totalXP",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "lastHPDamageTaken",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "lastHPDamageTaken_timer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "lastHPDamageTaken_turnNumber",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "mountedOn",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "mountedBy",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "crew",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "bodyParts",
          "type": "Dictionary<string, BodyPart>",
          "csType": "Dictionary<string, BodyPart>"
        },
        {
          "name": "partSpritesThatTakePriorityOverClass",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "keepWeaponsUnsheathedTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "keepWeaponsSheathedTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "supportAbilities",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "difficultyModeSupportAbilAdded",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "actions_timesUsed",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "invisibleTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatLabel",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combatLabel_color",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "_skinPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "_clothPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "_armorPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "hostile",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "facingRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "aiTarget",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "positionTC",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "destinationTC",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "canSwap",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "aiScript",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "timer",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "headSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "faceSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "legsSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "armLSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "armRSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "torsoSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "shoulderLSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "shoulderRSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "backSprite",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "ActorState": {
      "category": "nested",
      "fields": [
        {
          "name": "canSwap",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "busyTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "path",
          "type": "List<TileCoord>",
          "csType": "List<TileCoord>"
        },
        {
          "name": "facingRotAfterFinishedMoving",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "childActors",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "nextAction",
          "type": "ActionExecution",
          "csType": "ActionExecution"
        },
        {
          "name": "queuedAiActions",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "Fleet": {
      "category": "instance",
      "fields": [
        {
          "name": "boats",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "controllable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useStandardFleetAI",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "faction",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "goingToWaypoint",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "goal",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "cargo",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "commodoreID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "merchant",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "elite",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "turnsSpentStuck",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "Container": {
      "category": "nested",
      "fields": [
        {
          "name": "canOnlyContainItemsWithThisProperty",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "capacity",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "itemN",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "qN",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "IDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "quantity",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "movement",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "offset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "rot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "buried",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "broken",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "specialInfoTC",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "container",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "cantReactAgainTimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "highlight",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "index_temp",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "q",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "r",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "bu",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "br",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "timer",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "specialX",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "specialY",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "oX",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "oY",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "containedIn",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "cSlot",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "containerID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "maxWeight",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "infiniteStock",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "shopContainer",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "buyContainer",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "style",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "canContainAnything",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Location": {
      "category": "definition",
      "fields": [
        {
          "name": "x",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "y",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "xy",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneThisLocationIsIn",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneDescTitle",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "locationItem",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "externalSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltipIcons",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "tags",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "enterable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "port",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "discovered",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "discoverable",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "discoveryFameMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "discoverable_fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "showNameAsAPopupOnEntering",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "namePopup_texture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minimapIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minimapIcon_override",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "useWorldtimeZoneDarkness",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "adjustDarknessR",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "adjustDarknessG",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "adjustDarknessB",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "wealthLevel",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "marketRate",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "marketRate_newDay_change",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "cargo",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "stash",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "tradeGood_itemTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "cafeFood_itemTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "itemType_quantity",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "itemType_quantity_unlockable",
          "type": "Dictionary<string, List<float>>",
          "csType": "Dictionary<string, List<float>>"
        },
        {
          "name": "itemType_formula_unlockable",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "auto_spawnDataID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "shipwright_boatTypes",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "faction_favor",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "questTypes",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "questGoals",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "questRewards",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "dialogNodeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "GameState": {
      "category": "nested",
      "fields": [
        {
          "name": "saveName",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "playerActorID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "currentZoneName",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "money",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "currentWeather",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "AIPlan_ratingThresholdMod",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "AIMaxTimePerTurnMod",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "playerXPMultiplier",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "enemyStatsMultiplier",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "playerBonusMove",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "enemySpawnPowerMod",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "travelDifficulty",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "canSaveOutsidePort",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "timedHitsMode",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "stashListMode",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "cargoListMode",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "openStashCargoPosX",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "openStashCargoPosY",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "openPlayerInventoryPosX",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "openPlayerInventoryPosY",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "openCrewInventoryPosX",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "openCrewInventoryPosY",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "version",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "noteN",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "known",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "gameTime",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "worldTime",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "worldTime_daytimer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "worldTime_days",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "worldTime_sinceZoneChange",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "windRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "crewMorale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "mainPlayerActorID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "partyActors",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "partyActors_missing",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "partyActors_barracks",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "partyActors_overboard",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "partyActors_corpse",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "partyActors_dead",
          "type": "List<Actor>",
          "csType": "List<Actor>"
        },
        {
          "name": "reservedActorIDs",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "landingParty",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "knownClasses",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "knownJournalEntries",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "journalEntries_sold",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "journalNote",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "locations",
          "type": "Dictionary<string, Dictionary<string, Location>>",
          "csType": "Dictionary<string, Dictionary<string, Location>>"
        },
        {
          "name": "actionsOfPartyActors",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "partyActorsClassBookmarks",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "globalVars",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "globalVars_worldTimeAssigned",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "triggersFlaggedAsDone",
          "type": "Dictionary<string, List<int>>",
          "csType": "Dictionary<string, List<int>>"
        },
        {
          "name": "zonesVisited_lastWorldTime",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "killsOfActorType",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "recentlyUsedRandomNames",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "ticsUntilHelpGemIsUsable",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "helpGemEnabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "helpGemUnlocked",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "hiddenUI",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "stashInventory",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "cargoInventory",
          "type": "Container",
          "csType": "Container"
        },
        {
          "name": "wind_timer",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "wind_nextChangeInterval",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "masterVolume",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "soundVolume",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "musicVolume",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "intenseVisuals",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "retroVisuals",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "DyslexicFontMode",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "colorblind",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "PauseOnLossOfFocus",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "prioritizeKeyboardControls",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "fullscreen",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "borderless",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "fullscreenResolutionX",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "fullscreenResolutionY",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "controls_multiPressMaximumTime",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "cameraSpeed_combat",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "dialogSpeedMult",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "extraRacesUnlocked",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "extraOptionsUnlocked",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "enableErrorMessages",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "debugMode",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "ModInfo": {
      "category": "nested",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "nameWithoutSpecialChars",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "enabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "order",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "workshopMod",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "Trigger": {
      "category": "nested",
      "fields": [
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula",
          "virtual": true
        },
        {
          "name": "topX+",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "topY+",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "btmX+",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "btmY+",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "numID",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "aliasID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "topLeft",
          "type": "List<TileCoord>",
          "csType": "List<TileCoord>"
        },
        {
          "name": "btmRight",
          "type": "List<TileCoord>",
          "csType": "List<TileCoord>"
        },
        {
          "name": "triggerEffects",
          "type": "List<TriggerEffect>",
          "csType": "List<TriggerEffect>"
        },
        {
          "name": "triggerOnPlayerActorOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "onlyExecuteOnce",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "travelModeOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "triggerImmediatelyOnEnteringZone",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "triggeredByElement",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "triggerForEveryStepInArea",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "disableOnZoneEntry",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "reqFormula",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "TriggerEffect": {
      "category": "nested",
      "fields": [
        {
          "name": "effectID",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "sValue",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "sValue1",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "sValue2",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "fValue",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "xValue",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "yValue",
          "type": "integer",
          "csType": "int",
          "virtual": true
        },
        {
          "name": "delay",
          "type": "float",
          "csType": "float",
          "virtual": true
        },
        {
          "name": "bValue1",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "bValue2",
          "type": "boolean",
          "csType": "bool",
          "virtual": true
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "taskString",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "XYRefersToThisZone",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "numID",
          "type": "integer",
          "csType": "int",
          "virtual": true,
          "source": "DataManager"
        }
      ],
      "supportsCloneFrom": false
    },
    "ActorClass": {
      "category": "definition",
      "fields": [
        {
          "name": "bodyPartN",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "bodyPartSpriteN",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "description",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "selectableClass",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "actorValueXP",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "journalID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteActionR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteActionG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteActionB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteUI",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actions",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "relevantStats",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "avEffects",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "supportAbilities",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "ruinModeSupportAbility",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bodyPartSprites",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "requiredStat",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "requiredAmt",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Action": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltip",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "rankUpTooltip",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltipIcons",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltipTopRight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon_pR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon_pG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon_pB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "XPCostUnlock",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCostRankUp",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCostRankUpIncrement",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCost",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "chargeTime",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "mpCost",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "cooldown",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "primaryAvNum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxRank",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "canExceedMaxRankBy",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "canHaveAbilityTablet",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "numTargets",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "minDistanceBetweenTargets",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxDistanceBetweenTargets",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "FXChangesWithWeaponHand",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "AIRatingBias",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "AIRatingBias_rand",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "AIRatingMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "autolearnedByAI",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "harmful",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "attractAttention",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "roundFacingTo90",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "applyWeaponBuffs",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "special",
          "type": "List<specialProperty>",
          "csType": "List<specialProperty>"
        },
        {
          "name": "requiredWeaponElement",
          "type": "Element",
          "csType": "Element"
        },
        {
          "name": "checkOffhandRequirement",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "aoe",
          "type": "AreaOfEffect",
          "csType": "AreaOfEffect"
        },
        {
          "name": "avAffecters",
          "type": "List<ActorValueAffecter>",
          "csType": "List<ActorValueAffecter>"
        },
        {
          "name": "FXOnCaster",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTarget",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnCasterColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTargetColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "queueAnotherAction",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "fReq_queueAnotherAction",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "casterAnimation",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "casterAnimationDependsOnWeaponHand",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "casterAnimationDependsOnFacingRot",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "casterAnimationSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "casterAnimationLoops",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ActorValueAffecter": {
      "category": "nested",
      "fields": [
        {
          "name": "duration",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "chance",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actorValue",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "element",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "magnitude",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "durationIsWorldtimeDays",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "weaponAvAffecter",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "removeTheseElementsFromWeaponAvAffecter",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "showWeaponAvAffecterFX",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "addAsWeaponAvAffecter",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useMyAoEWhenAddingAsWeaponAvAffecter",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "harmful",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "hideAllEffects",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "visibleEvaluations",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "visibleMiss",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "prefixIcon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "forActEvalPurposesOnly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "hideActEval",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "stacksWithSelf",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useCasterAsOriginForDirectionalEffects",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useSeparateChanceRoll",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "requiresPreviousAVHit",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rotOverride",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "rankRequired",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "aoe",
          "type": "AreaOfEffect",
          "csType": "AreaOfEffect"
        },
        {
          "name": "affectIntangible",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "applyElementToTile",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "affectGlobalAvAffecterInfo",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "FXOnTarget",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTile",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnHit",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnMiss",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTargetColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTileColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnHitColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnMissColor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "FXOnTargetTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "FXOnTileTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "FXOnHitTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "FXOnMissTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "SupportAbility": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltip",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "rankUpTooltip",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltipIcons",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "tooltipTopRight",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "icon",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "XPCostUnlock",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCostRankUp",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCostRankUpIncrement",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "XPCostRankUpMultiplier",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxRank",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "canBeGivenToAI",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "reactions",
          "type": "List<ElementReaction>",
          "csType": "List<ElementReaction>"
        },
        {
          "name": "effects",
          "type": "List<ActorValueEffect>",
          "csType": "List<ActorValueEffect>"
        },
        {
          "name": "emitFxWhileMoving",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fxEvery4Frames",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "supportAbilsToReplace",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "supportAbilReplaceAliasID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "LevelData": {
      "category": "definition",
      "fields": [
        {
          "name": "worldSizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "worldSizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "chanceOfForwardPath",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "pathSize_inner",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "minZoneSizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxZoneSizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minZoneSizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxZoneSizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "zoneData",
          "type": "Zone",
          "csType": "Zone"
        },
        {
          "name": "triggers",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "setPieces",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "setPiecesChanceToReroll",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "minSetPiecesPerRoom",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxSetPiecesPerRoom",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "chooseCenterPiecesInOrder",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "centerPieces",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "centerPiecesChanceToReroll",
          "type": "List<Formula>",
          "csType": "List<Formula>"
        },
        {
          "name": "centerPieceChance_normal",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "centerPieceChance_deadEnd",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "centerPieceChance_1stRoom",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "addGuaranteedSetPiecesFirst",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "guaranteedSetPieces",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "mandatorySetPieces",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "mandatoryCenterPieces",
          "type": "Dictionary<string, List<string>>",
          "csType": "Dictionary<string, List<string>>"
        },
        {
          "name": "cannotHaveMandatorySetOrCenterPieces",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "intialExitIsAReturnPath",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "extraSetPieceTries",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minWallThickness",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "maxWallThickness",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "minWallFlatStretch",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "wallChanceToZig",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "wallChanceToZag",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "wallType",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "wallTypeBottom",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "defaultTile",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "wallType_exit",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "wallTypeBottom_exit",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "defaultTile_exit",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minExitWidth",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxExitWidth",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "exitCurveAverageDepth",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "exitCurveVariation",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "exitExtendInwardDistMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "extraPureBlackBorder",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "extraPureBlackBorder_terrainTypeOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnItems_onWall_chance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spawnItems_onWall",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnItems_onWall_chanceToReroll",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "spawnItems_nearWall_chance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spawnItems_nearWall",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnItems_nearWall_chanceToReroll",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "spawnItems_nearCenter_chance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spawnItems_nearCenter",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnItems_nearCenter_chanceToReroll",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "canSpawnItemsWithinSetPieces",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "otherLevelData",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "otherLevelData_chance",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "otherLevelData_chance_deadEnd",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "carvePath_betweenExits_terrainTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "carvePath_betweenExits_straight_minLength",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_betweenExits_turn_minLength",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_betweenExits_width",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_betweenExits_chanceToTurn",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "carvePath_fromExitToCenterPiece_terrainTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "carvePath_fromExitToCenterPiece_straight_minLength",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_fromExitToCenterPiece_turn_minLength",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_fromExitToCenterPiece_width",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "carvePath_fromExitToCenterPiece_chanceToTurn",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "centeredExits",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "specialSpawns",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "borderTheseTiles",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "SetPiece": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneName",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "canOverlapWalls",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canOverwriteWallBtms",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canOverwriteWalls",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysPlaceNoMatterWhat",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "replaceItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "minDistFromXWalls",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxDistFromXWalls",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minDistFromYWalls",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxDistFromYWalls",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "onlySpawnOnIncrementsX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "onlySpawnOnIncrementsY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "onlyAssessMaxYDistFromTopWall",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canBeRotated",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canBeFlippedX",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canBeFlippedY",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "sizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "useLevelDataTerrainTypes",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "setXPosPercent",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "setYPosPercent",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "addSPAfterCarvingPaths",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "usableInBuildMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "SpawnData": {
      "category": "definition",
      "fields": [
        {
          "name": "minActors",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxActors",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "maxDifferentTypes",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "actorTypesMins",
          "type": "Dictionary<string, integer>",
          "csType": "Dictionary<string, int>"
        },
        {
          "name": "actorTypesMaxes",
          "type": "Dictionary<string, integer>",
          "csType": "Dictionary<string, int>"
        },
        {
          "name": "actorClassesMins",
          "type": "Dictionary<string, integer>",
          "csType": "Dictionary<string, int>"
        },
        {
          "name": "actorClassesMaxes",
          "type": "Dictionary<string, integer>",
          "csType": "Dictionary<string, int>"
        },
        {
          "name": "actorTypesChanceToReroll",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "actorClassesChanceToReroll",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "extraSpawnDataIDs",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "extraSpawnDataMins",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "extraSpawnDataMaxes",
          "type": "List<integer>",
          "csType": "List<int>"
        },
        {
          "name": "extraSpawnDataChances",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "spawnExtraSpawnDataInOrder",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "valuesDictOverrides",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "mandatoryItemsPerActor_actorTypeID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "mandatoryItemsPerActor_itemID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "optionalItemsPerActor_actorTypeID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "optionalItemsPerActor_itemID",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "optionalItemsChanceToBeNothing",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "availableWeapons",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "availableArmors",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "forbiddenAbilities",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "forcedSupportAbilities",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "fleetCargo",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "fleetCargo_chanceToAdd",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "bonusAVs",
          "type": "Dictionary<string, float>",
          "csType": "Dictionary<string, float>"
        },
        {
          "name": "minOptionalLootPerActor",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxOptionalLootPerActor",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minGoldPerActor",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxGoldPerActor",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "bodyPartSpriteOverride",
          "type": "Dictionary<string, string>",
          "csType": "Dictionary<string, string>"
        },
        {
          "name": "clothPaletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "skinPaletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "factionOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "aiOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialogOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "statementPrefixOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "dialogOverride_appendNum_max",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "musicOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "facingRotOverride",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "braveryMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "hostile",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canDespawn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canManipCorpse",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "noPassives",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "random10percentHPMPBoost",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "spawnAsBarracksRecruit",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "spawnFX",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "SpecialSpawn": {
      "category": "definition",
      "fields": [
        {
          "name": "offsetsToCheck",
          "type": "List<TileCoord>",
          "csType": "List<TileCoord>"
        },
        {
          "name": "IDsToCheckFor",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "elementToCheckFor",
          "type": "List<Element>",
          "csType": "List<Element>"
        },
        {
          "name": "spawnID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "terrainID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minQuantity",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maxQuantity",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minDistFromZoneBounds",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minDistFromPlayer",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "quantityInfluenceMod",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "applyRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "percentChance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "adjustWallTypesAccordingly",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "removeItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "itemMustFit",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "quickSpawnMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Faction": {
      "category": "definition",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name_possessive",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "name_long",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "capital_locationID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnInZone",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "minimumFleets_merchant",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "minimumFleets_battle",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maximumFleets_merchant",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "maximumFleets_battle",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "spawnChance_merchant_min",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "spawnChance_merchant_max",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "spawnChance_battle_min",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "spawnChance_battle_max",
          "type": "Formula",
          "csType": "Formula"
        },
        {
          "name": "minimapColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "rankTitles",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "rankIcons",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "commodore_actorPrefabs_merchant",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "commodore_actorPrefabs_battle",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "commodore_actorPrefabs_battle_elite",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "powerMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "factionWealthOverride",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "canInvest",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "humanoidManned",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "trackFavor",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "FXData": {
      "category": "definition",
      "fields": [
        {
          "name": "particleID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "numParticles",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "posOffset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "randPos",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "posOffsetPerParticle",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "velocOffset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "randVeloc",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "accelOffset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "randAccel",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "targetPosOffset",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "minimumVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "minimumPosDist",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotVelocOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotOffsetPerParticle",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleVelocOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleOffsetPerParticle",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleAccelOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "speedOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randRot",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randRotVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randScale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randScaleVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "alphaOffset",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "alphaVelocOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randAlphaVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "alphaAccelOffset",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "initialDelayIncreasePerParticle",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "randInitialDelay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "initialDelayMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "durationMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rand_durationMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "depthMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "shake",
          "type": "Screenshake",
          "csType": "Screenshake"
        },
        {
          "name": "tint",
          "type": "ScreenTint",
          "csType": "ScreenTint"
        },
        {
          "name": "timeSpeedModOverride",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "timeSpeedMod",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "timeSpeedModDuration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelToTargetSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "removeAtDestination",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "stopAtDestination",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "flicker",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "hideLight",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "intenseVisual",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "divideSourceRectBetweenParticles",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "addRotToTextureID",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "addCasterRotation",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "roundRotToNearest",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotateBasedOnVelocity",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "useTerrainDepth",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "loopAroundZoneEdge",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawOnlyIfRoofsAreDrawn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "percentDurationBeforeOverlapWithOtherFX",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "soundName",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "soundVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "soundPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "soundPitchRand",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "soundDistanceMult",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "soundDropoffDist",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "alphaZero_dropoffScreenDist",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "spawnFXatEnd",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndAoEID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNear",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNearColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNear_distance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "pR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "flip",
          "type": "SpriteEffects",
          "csType": "SpriteEffects"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "Screenshake": {
      "category": "nested",
      "fields": [
        {
          "name": "magnitude",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "duration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "xShake",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "yShake",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "delay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ScreenTint": {
      "category": "nested",
      "fields": [
        {
          "name": "color",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "whiteTint",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fadeInTime",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "duration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "fadeSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "delay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "paletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "darknessColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "applyTintToUI",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "drawOrderFX": {
      "category": "definition",
      "fields": [
        {
          "name": "No such texture as N",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "pattern": true
        },
        {
          "name": "position",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "color",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "rotation",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "origin",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "scale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "sprEffect",
          "type": "SpriteEffects",
          "csType": "SpriteEffects"
        },
        {
          "name": "depth",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "texture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sourceRect",
          "type": "Rectangle",
          "csType": "Rectangle"
        },
        {
          "name": "pR",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pG",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "pB",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "speed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "timePerFrame",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "duration",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "positionIsScreenPosition",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alphaZero_dropoffScreenDist",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "removeAtDestination",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "stopAtDestination",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "flickerEveryFrame",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "veloc",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "accel",
          "type": "Vector2",
          "csType": "Vector2"
        },
        {
          "name": "rotVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "rotAccel",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "scaleAccel",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "alphaVeloc",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "alphaAccel",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "addRotToTextureID",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rotateBasedOnVelocity",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "roundRotToNearest",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "useTerrainDepth",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "loop",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "ignoreDarkness",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "scaleLightSizeAndAlpha",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "loopAroundZoneEdge",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawOnlyIfRoofsAreDrawn",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "playWhileGameIsPaused",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "light",
          "type": "Light",
          "csType": "Light"
        },
        {
          "name": "spawnFXatEnd",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndAoEID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNear",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNearColor",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "spawnFXatEndIfActorNear_distance",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "initialDelay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": true
    },
    "ActTimer": {
      "category": "nested",
      "fields": [
        {
          "name": "timer",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "timeToAct",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "IDnum",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "recurring",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "paused",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "forTestPurposes",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "actorID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "actionToBeExecuted",
          "type": "ActionExecution",
          "csType": "ActionExecution"
        },
        {
          "name": "itemTimed",
          "type": "Item",
          "csType": "Item"
        },
        {
          "name": "itemTC",
          "type": "TileCoord",
          "csType": "TileCoord"
        },
        {
          "name": "ID",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        },
        {
          "name": "cloneFrom",
          "type": "string",
          "csType": "string",
          "virtual": true,
          "source": "DataManager (common)"
        }
      ],
      "supportsCloneFrom": false
    },
    "Zone": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "locID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "showFogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "minimapEnabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "dark",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "darknessColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "allowCameraPastZoneEdges",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rollingPinStyle",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky_overrideYpos",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "peaceful",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overseerMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "boatZone",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "wind",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overworld",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantAct",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canDropItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantGameOver",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysKeepWeaponsUnsheathed",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "zoneDirtPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneDirtDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStonePalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneLightPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWaterPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc1Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc2Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc3Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc4Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc5Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc6Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc7Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc8Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "darkenedTileTexture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgTerrainTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFXID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFX_sineWave",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgScale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgParallaxRatio",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedX",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedY",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "travelSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combatSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongDelay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp_reflect",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "zoneFX",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "zoneFXTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_x",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_y",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "timeUntilNewDay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "actors",
          "type": "Dictionary<string, Actor>",
          "csType": "Dictionary<string, Actor>"
        },
        {
          "name": "triggers",
          "type": "List<Trigger>",
          "csType": "List<Trigger>"
        },
        {
          "name": "actTimers",
          "type": "List<ActTimer>",
          "csType": "List<ActTimer>"
        },
        {
          "name": "darkR",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkG",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkB",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "combatMode",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string",
          "virtual": true
        }
      ],
      "supportsCloneFrom": false
    },
    "LevelDataZone": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "locID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "showFogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "minimapEnabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "dark",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "darknessColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "allowCameraPastZoneEdges",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rollingPinStyle",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky_overrideYpos",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "peaceful",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overseerMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "boatZone",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "wind",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overworld",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantAct",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canDropItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantGameOver",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysKeepWeaponsUnsheathed",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "zoneDirtPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneDirtDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStonePalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneLightPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWaterPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc1Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc2Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc3Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc4Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc5Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc6Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc7Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc8Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "darkenedTileTexture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgTerrainTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFXID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFX_sineWave",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgScale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgParallaxRatio",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedX",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedY",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "travelSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combatSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongDelay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp_reflect",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "zoneFX",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "zoneFXTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_x",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_y",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "timeUntilNewDay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "actors",
          "type": "Dictionary<string, Actor>",
          "csType": "Dictionary<string, Actor>"
        },
        {
          "name": "triggers",
          "type": "List<Trigger>",
          "csType": "List<Trigger>"
        },
        {
          "name": "actTimers",
          "type": "List<ActTimer>",
          "csType": "List<ActTimer>"
        },
        {
          "name": "darkR",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkG",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkB",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "combatMode",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string",
          "virtual": true
        }
      ],
      "supportsCloneFrom": false
    },
    "HeightMap": {
      "category": "special",
      "fields": [
        {
          "name": "h",
          "type": "string",
          "csType": "string"
        }
      ],
      "supportsCloneFrom": false
    },
    "FormulaGlobal": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "formula",
          "type": "Formula",
          "csType": "string"
        }
      ],
      "supportsCloneFrom": false
    },
    "GlobalFormula": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "formula",
          "type": "Formula",
          "csType": "string"
        }
      ],
      "supportsCloneFrom": false
    },
    "Palette": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "num",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "animated",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "animatedSlow",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "animatedFast",
          "type": "boolean",
          "csType": "bool"
        }
      ],
      "supportsCloneFrom": false
    },
    "ZoneMerge": {
      "category": "special",
      "fields": [
        {
          "name": "ID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "locID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "sizeX",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "sizeY",
          "type": "integer",
          "csType": "int"
        },
        {
          "name": "showFogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "fogOfWar",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "minimapEnabled",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "dark",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "darknessColor",
          "type": "Color",
          "csType": "Color"
        },
        {
          "name": "allowCameraPastZoneEdges",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "rollingPinStyle",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "drawSky_overrideYpos",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "peaceful",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overseerMode",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "boatZone",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "wind",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "overworld",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantAct",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "canDropItems",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "cantGameOver",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "alwaysKeepWeaponsUnsheathed",
          "type": "boolean",
          "csType": "bool"
        },
        {
          "name": "zoneDirtPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneDirtDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneGrassDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStonePalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneLightPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneStoneDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWaterPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneWoodDarkPalette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc1Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc2Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc3Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc4Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc5Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc6Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc7Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "zoneMisc8Palette",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "paletteOverride",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "darkenedTileTexture",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgTerrainTypeID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFXID",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "bgFX_sineWave",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgScale",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgParallaxRatio",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedX",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "bgMoveSpeedY",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "travelSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "travelSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSong",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "combatSongVolume",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongPitch",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "combatSongDelay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveFreq",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenDarkWaveAmp",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveSpeed",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "screenWaveAmp_reflect",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "zoneFX",
          "type": "List<string>",
          "csType": "List<string>"
        },
        {
          "name": "zoneFXTime",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_x",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "zoneFX_y",
          "type": "List<float>",
          "csType": "List<float>"
        },
        {
          "name": "timeUntilNewDay",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "actors",
          "type": "Dictionary<string, Actor>",
          "csType": "Dictionary<string, Actor>"
        },
        {
          "name": "triggers",
          "type": "List<Trigger>",
          "csType": "List<Trigger>"
        },
        {
          "name": "actTimers",
          "type": "List<ActTimer>",
          "csType": "List<ActTimer>"
        },
        {
          "name": "darkR",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkG",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "darkB",
          "type": "byte",
          "csType": "byte",
          "virtual": true
        },
        {
          "name": "combatMode",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "name",
          "type": "string",
          "csType": "string",
          "virtual": true
        },
        {
          "name": "X",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "Y",
          "type": "float",
          "csType": "float"
        },
        {
          "name": "mergeWith",
          "type": "string",
          "csType": "string"
        },
        {
          "name": "fReq",
          "type": "Formula",
          "csType": "string"
        }
      ],
      "supportsCloneFrom": false
    }
  },
  "typeAliases": {
    "TerrainLight": "Light",
    "TerrainReaction": "ElementReaction",
    "ActorValueReaction": "ElementReaction",
    "ActorTypeAoE": "AreaOfEffect",
    "ActorTypeAOE": "AreaOfEffect",
    "ActorTypeDetectAoE": "AreaOfEffect",
    "ActorTypeDetectAOE": "AreaOfEffect",
    "ActorTypeReaction": "ElementReaction",
    "AvEffect": "ActorValueEffect",
    "ActorTypeLight": "Light",
    "ItemEffect": "ActorValueEffect",
    "ItemEffectInWeapon": "ActorValueEffect",
    "ItemEffectInArmor": "ActorValueEffect",
    "ItemLight": "Light",
    "ItemReaction": "ElementReaction",
    "ItemReactionInWeapon": "ElementReaction",
    "ItemReactionInArmor": "ElementReaction",
    "ActorItem": "Item",
    "ActorGateItem": "Item",
    "ActorClone": "Actor",
    "ActorCrew": "Actor",
    "FleetBoat": "Actor",
    "FleetCargo": "Container",
    "FleetCargoItem": "Item",
    "StashItem": "Item",
    "CargoItem": "Item",
    "LocationContainer": "Container",
    "LocationItem": "Item",
    "GlobalTrigger": "Trigger",
    "GlobalTriggerEffect": "TriggerEffect",
    "PlayerActor": "Actor",
    "PlayerActorMissing": "Actor",
    "PlayerActorBarracks": "Actor",
    "PlayerActorDead": "Actor",
    "PlayerActorCorpse": "Actor",
    "ActorPrefab": "Actor",
    "ActorSavePrefab": "Actor",
    "ActorAOE": "AreaOfEffect",
    "ActorAoE": "AreaOfEffect",
    "GlobalAoE": "AreaOfEffect",
    "GlobalAOE": "AreaOfEffect",
    "ActorInventory": "Container",
    "ActorContainer": "Container",
    "ActorGateInventory": "Container",
    "ActorGateContainer": "Container",
    "ActorEffect": "ActorValueEffect",
    "ActorClassReaction": "ElementReaction",
    "ActorClassEffect": "ActorValueEffect",
    "ActionAoE": "AreaOfEffect",
    "ActionAOE": "AreaOfEffect",
    "AvAffecter": "ActorValueAffecter",
    "AvAffecterAoE": "AreaOfEffect",
    "AvAffecterAOE": "AreaOfEffect",
    "SupportAbilityReaction": "ElementReaction",
    "SupportAbilityEffect": "ActorValueEffect",
    "Screentint": "ScreenTint",
    "drawOrderFXLight": "Light",
    "actTimer": "ActTimer"
  },
  "functionalAliases": {
    "ActorTypeAOE": "ActorTypeAoE",
    "ActorTypeDetectAoE": "ActorTypeAoE",
    "ActorTypeDetectAOE": "ActorTypeAoE",
    "ActorAoE": "ActorAOE",
    "GlobalAOE": "GlobalAoE",
    "ActorContainer": "ActorInventory",
    "ActorGateContainer": "ActorGateInventory",
    "ActionAOE": "ActionAoE",
    "AvAffecterAOE": "AvAffecterAoE",
    "FormulaGlobal": "GlobalFormula",
    "Screentint": "ScreenTint",
    "ElementAssociations": "ElementAssociation"
  },
  "enums": {
    "ShadowType": {
      "Solid": 1,
      "Illuminated": 2,
      "Occluded": 3
    },
    "Task.TaskType": {
      "none": -1,
      "clear": 0,
      "debug_drawStrings": 1,
      "action": 2,
      "actionOnPartyNumActor": 3,
      "applyElement": 4,
      "applyElementToArea": 5,
      "applyElementToZone": 6,
      "setTileTerrain": 7,
      "script": 8,
      "consolecommand": 9,
      "togglePause": 10,
      "preventInteraction": 11,
      "delayActions": 12,
      "cutsceneMode": 13,
      "timeSpeed": 14,
      "setFactionHostile": 15,
      "setFactionAI": 16,
      "killFaction": 17,
      "removeFaction": 18,
      "changeFaction": 19,
      "moveToNewZone": 20,
      "travel": 21,
      "travel_point": 22,
      "travel_point_g": 23,
      "travel_leaveLocation": 24,
      "travel_gVars": 25,
      "travel_noSave": 26,
      "travel_procedural": 27,
      "travel_procedural_point": 28,
      "travel_setReturnPath": 29,
      "returnPath": 30,
      "travel_g": 31,
      "setGlobalVar": 32,
      "setGlobalVar_math": 33,
      "setGlobalVar_toOtherGlobalVar": 34,
      "setGlobalVar_toPartyActorID": 35,
      "setGlobalVar_toActorID": 36,
      "setGlobalVarToZoneProperty": 37,
      "setGlobalVarWithCommas": 38,
      "clearGlobalVar": 39,
      "enableUI": 40,
      "disableUI": 41,
      "unlockHelpGem": 42,
      "enableHelpGem": 43,
      "disableHelpGem": 44,
      "save": 45,
      "quietsave": 46,
      "heal": 47,
      "healparty": 48,
      "healfaction": 49,
      "fullrestore": 50,
      "revive": 51,
      "fx": 52,
      "sfx": 53,
      "fxOnTalker": 54,
      "fxOnParty": 55,
      "damageNumber": 56,
      "damageNumber_worldTime": 57,
      "animate": 58,
      "textOverlay": 59,
      "textOverlay_tween": 60,
      "textOverlay_dynamic": 61,
      "pointCameraAt": 62,
      "lockCameraAt": 63,
      "scaleCameraTo": 64,
      "setRoofDrawNoMatterWhat": 65,
      "cancelIfEnemiesPresent": 66,
      "cancelIfEnemiesNotPresent": 67,
      "cancelIfItemPresent": 68,
      "cancelIfItemNotPresent": 69,
      "cancelIf": 70,
      "facingRot": 71,
      "facingRotParty": 72,
      "song": 73,
      "playSong": 74,
      "playNearestLocationSong": 75,
      "setZoneSongs": 76,
      "removeItem": 77,
      "removeActorItem": 78,
      "removeItemsNearPlayerActor": 79,
      "removeItemOfValue": 80,
      "removeEmptyItem": 81,
      "removeAllItems": 82,
      "removeAllItemsOfValue": 83,
      "removeHeldItems": 84,
      "addItem": 85,
      "addItemToContainer": 86,
      "spawnItem": 87,
      "moveItems": 88,
      "moveItemsToActor": 89,
      "replaceEquipment": 90,
      "dropItem": 91,
      "buryAllItemsOfType": 92,
      "buryGlobalVarItems": 93,
      "buryLocations": 94,
      "reactOnMatchingItems": 95,
      "specialKeyStatusUpdate": 96,
      "removeActor": 97,
      "removeActorType": 98,
      "removeActors_despawnable": 99,
      "setActorFloat": 100,
      "setActorBool": 101,
      "setActorAI": 102,
      "setActorName": 103,
      "setActorIdleAnimOverride": 104,
      "setActorDialogNodeID": 105,
      "setActorAIActions": 106,
      "setActorPalettes": 107,
      "setFaceSprite": 108,
      "setCurrentActor_partSpritesThatTakePriorityOverClass": 109,
      "giveActorsBaseXP": 110,
      "moveActor": 111,
      "moveActor_point": 112,
      "movePartyTo": 113,
      "movePartyTo_point": 114,
      "movePartyBy": 115,
      "moveAllActorsBy": 116,
      "addToParty": 117,
      "addTalkerToParty": 118,
      "addTalkerToParty_temp": 119,
      "removeFromParty": 120,
      "handleTiredStates": 121,
      "hideParty": 122,
      "path": 123,
      "pathParty": 124,
      "destination": 125,
      "movement": 126,
      "addZoneFX": 127,
      "createZoneSpecialFX": 128,
      "removeZoneFX": 129,
      "setZonePalettes": 130,
      "setZonePeaceful": 131,
      "disableFog": 132,
      "setZoneRollingPinStyle": 133,
      "screenDarkWaveEffect": 134,
      "changeZoneDarkColor": 135,
      "setZoneDarkColor": 136,
      "setZoneDarkness": 137,
      "setZoneDarknessToWorldDarkness": 138,
      "screenWaveEffect": 139,
      "setZoneBG": 140,
      "setZoneBGFX": 141,
      "initWaypoints": 142,
      "safe": 143,
      "sendAISignal": 144,
      "disableTrigger": 145,
      "resetTrigger": 146,
      "enableTrigger": 147,
      "trigger": 148,
      "addTrigger": 149,
      "removeTrigger": 150,
      "specialSpawn": 151,
      "spawn": 152,
      "spawn_g": 153,
      "spawn_g_nearPlayer": 154,
      "spawn_actorPrefab": 155,
      "spawn_actorPrefab_point": 156,
      "spawn_actorPrefab_point_specialZone": 157,
      "spawn_location": 158,
      "spawn_onItem": 159,
      "spawn_seamonster": 160,
      "spawn_sm": 161,
      "spawn_fleet": 162,
      "spawn_corpse": 163,
      "talk": 164,
      "tryDialog": 165,
      "tryDialog_commodore": 166,
      "exitDialog": 167,
      "attractAttention": 168,
      "attractAttentionToPlayer": 169,
      "executeDialogEffect": 170,
      "loadSpecialZone": 171,
      "loadSpecialZone_precision": 172,
      "loadSpecialZone_playerFlagship": 173,
      "loadSpecialZone_playerFlagship_precision": 174,
      "moveSpecialZone": 175,
      "moveSpecialZone_precision": 176,
      "scaleSpecialZone": 177,
      "mergeSpecialZone": 178,
      "barracksLineup": 179,
      "unlockExtras": 180,
      "trySetAchievement": 181,
      "resetLocations": 182,
      "refreshUndamagedShipZones": 183,
      "boardActor": 184,
      "endBoarding": 185,
      "enterFleetBattle": 186,
      "setDialogSpeed": 187,
      "setMoney": 188,
      "enterCombat": 189,
      "enterCombat_timer": 190,
      "exitCombat": 191,
      "offerRest": 192,
      "advanceTimers": 193,
      "scoreScreen": 194,
      "setupGraveyard": 195,
      "endGame": 196,
      "handleDeaths": 197,
      "getResponse_combat": 198,
      "getResponse_peace": 199,
      "getResponse_bribe": 200,
      "getBribeAmount": 201,
      "subtractBribeAmount": 202,
      "stealloc": 203,
      "add50gp": 204,
      "addgp": 205,
      "subtractgp": 206,
      "subtract10gp": 207,
      "subtract20gp": 208,
      "subtract30gp": 209,
      "subtract40gp": 210,
      "subtract50gp": 211,
      "subtract60gp": 212,
      "subtract75gp": 213,
      "subtract100gp": 214,
      "subtract130gp": 215,
      "subtract150gp": 216,
      "subtract200gp": 217,
      "subtract250gp": 218,
      "subtract300gp": 219,
      "subtract350gp": 220,
      "subtract400gp": 221,
      "subtract500gp": 222,
      "subtract800gp": 223,
      "subtract1000gp": 224,
      "subtract5000gp": 225,
      "subtract10000gp": 226,
      "subtractAllgp": 227,
      "dominateworld": 228,
      "giveGlobalVarGP": 229,
      "enterSellMode": 230,
      "openCargo": 231,
      "autobuy_food": 232,
      "enterSellMode_cargo": 233,
      "enterSellMode_stash": 234,
      "enterBuyMode": 235,
      "enterBuyMode_location": 236,
      "enterBuyMode_locationItems": 237,
      "enterBuyMode_fleet": 238,
      "setBuyPriceMult": 239,
      "buyItem_confirmWindow": 240,
      "buyGoods_confirmWindow": 241,
      "buyFood_fillCargo": 242,
      "buyFood": 243,
      "buyGoods": 244,
      "giveFood": 245,
      "lose10Food": 246,
      "removeCargo": 247,
      "removeCargo_g": 248,
      "removeItem_g": 249,
      "removeItemFromParty": 250,
      "refreshStatMods": 251,
      "grantXPShare_5percent": 252,
      "hostile": 253,
      "playerInitiateCombat": 254,
      "enemyInitiateCombat": 255,
      "enterFleetBattle_player": 256,
      "giveQuestItemReward": 257,
      "reassignQuestItem": 258,
      "gotoNodeIf": 259,
      "gotoIf": 260,
      "gotoNodeDelay": 261,
      "delayDialog": 262,
      "incOnNewDay": 263,
      "incDefaultNode": 264,
      "setMyNode": 265,
      "setDefaultNode": 266,
      "setAsDialogNode": 267,
      "setAsMyNode": 268,
      "setMyNodeIf": 269,
      "setDefaultNodeIf": 270,
      "clearDialogNode": 271,
      "flee": 272,
      "enemyFlee": 273,
      "playerFlee": 274,
      "enemyMoraleUp": 275,
      "enemyMoraleDown": 276,
      "playerMoraleUp": 277,
      "crewMorale": 278,
      "peace": 279,
      "peaceXPrewardOnly": 280,
      "moveCamXY": 281,
      "moveXY": 282,
      "moveX1": 283,
      "moveY1": 284,
      "moveXNeg1": 285,
      "moveYNeg1": 286,
      "playerFacingRot": 287,
      "playerAnim": 288,
      "facingRot90": 289,
      "facingRot180": 290,
      "facingRot0": 291,
      "facingRot270": 292,
      "facingRotPrev": 293,
      "setPrevFacingRot": 294,
      "lookAtTalker": 295,
      "lookAtPlayer": 296,
      "setAI_idle": 297,
      "setAI_idle_flag": 298,
      "die": 299,
      "crash": 300,
      "escapeGate": 301,
      "removeTalker": 302,
      "setDialogWindowSizeY": 303,
      "setNPCDialogWindowSizeY": 304,
      "setOnlyNPCDialogWindowSizeY": 305,
      "setDialogWindowSizeYAuto": 306,
      "setPCDialogWindowSizeY": 307,
      "resetPCDialogWindowSizeY": 308,
      "showCharstats": 309,
      "showQuickslots": 310,
      "hideQuickslots": 311,
      "setCombatUIVisible": 312,
      "showEscFactionWindow": 313,
      "hideEscWindows": 314,
      "unlockGem": 315,
      "modGlobalVar": 316,
      "modNodeIDGlobalVar_1": 317,
      "modNodeIDGlobalVar_999": 318,
      "setNodeIDGlobalVar_1": 319,
      "appendToGlobalVar": 320,
      "appendToGlobalVar_math": 321,
      "appendToGlobalVar_string": 322,
      "appendToGlobalVar_zoneID": 323,
      "appendToGlobalVar_locID": 324,
      "setGlobalVarTo0": 325,
      "setGlobalVarToTalkerID": 326,
      "setGlobalVarWithTalkerID": 327,
      "setGlobalVarToLocID": 328,
      "setGlobalVarToPartyActorNum": 329,
      "setGlobalVarPlusLocID": 330,
      "setGlobalVarPlusLocID_math": 331,
      "setGlobalVarPlusZoneID": 332,
      "modFame": 333,
      "goToNodeID_plus_GlobalVar": 334,
      "scoreScreenResponse": 335,
      "research_report": 336,
      "cartographer_report": 337,
      "donate": 338,
      "jobDialogOptions": 339,
      "refreshLocQuests": 340,
      "cancelQuest": 341,
      "cancelRoyalQuest": 342,
      "cleanUpQuest": 343,
      "royalJobDialogOptions": 344,
      "refreshRoyalQuests": 345,
      "refreshRoyalTitle": 346,
      "setupBuyShipDialog": 347,
      "buyShip": 348,
      "giveShip": 349,
      "renameShip": 350,
      "addToFleet": 351,
      "addToFleet_andSwapWithFleet_slot": 352,
      "removeFromParty_slot": 353,
      "removeFromFleet_slot": 354,
      "researchFromFleet_slot": 355,
      "enterPort": 356,
      "enterLocation": 357,
      "buyLocationFood": 358,
      "invest": 359,
      "modTalkerFavor": 360,
      "modLocFavor": 361,
      "modLocWealthLevel": 362,
      "setLocDiscoverable": 363,
      "createMonsterDenNearby": 364,
      "bezoar_setupportselect": 365,
      "cameraAtPlayer": 366,
      "cameraAtTalker": 367,
      "cameraAtPoint": 368,
      "cameraAtPointLock": 369,
      "talkToOtherActor": 370,
      "giveItem": 371,
      "triggerEffect": 372,
      "dialogEffect": 373,
      "nextDialogNode_hideWindow": 374,
      "closeCharEdit": 375,
      "gameOver": 376,
      "autosaveASAP": 377,
      "noSpeechFXLookOrAnim": 378,
      "speechFX": 379,
      "fxOnPlayerRank": 380,
      "returnMissingPartyMembers": 381,
      "modPlayerFactionFavor": 382,
      "modTalkerFactionFavor": 383,
      "refreshStatModifiers": 384,
      "storeBoost": 385,
      "recoverOverboardPartyActors": 386,
      "talkToCommodore": 387,
      "talkToFirstMate": 388,
      "talkToFlagship": 389,
      "setupFleetLooting": 390,
      "captureShips_afterCombat": 391,
      "captureShipNum": 392,
      "lootFleet_afterCombat": 393,
      "openFleetWindow": 394,
      "openFleetWindow_delay": 395,
      "openFleetWindow_talker": 396,
      "closeFleetWindow": 397,
      "showFleetInfo": 398,
      "repairFleet_pay": 399,
      "repairFleet_free": 400,
      "retro": 401,
      "help": 402,
      "h": 403,
      "csave": 404,
      "testitemload": 405,
      "howmanyitems": 406,
      "convertRGB": 407,
      "screenshot": 408,
      "screenpic": 409,
      "anim": 410,
      "fullheal": 411,
      "rest": 412,
      "testboatanim": 413,
      "bighead": 414,
      "screenscale": 415,
      "res": 416,
      "go": 417,
      "gob": 418,
      "p": 419,
      "world": 420,
      "w": 421,
      "loads": 422,
      "z": 423,
      "sp": 424,
      "bz": 425,
      "k": 426,
      "kills": 427,
      "kill": 428,
      "killall": 429,
      "killcrew": 430,
      "reviveall": 431,
      "win": 432,
      "setk": 433,
      "set": 434,
      "get": 435,
      "calc": 436,
      "math": 437,
      "resetfog": 438,
      "fog": 439,
      "cfog": 440,
      "clearfog": 441,
      "hidemapicon": 442,
      "hidemapicons": 443,
      "clearitems": 444,
      "removeitems": 445,
      "clearroofs": 446,
      "clearroof": 447,
      "deleteZone": 448,
      "forget": 449,
      "resetloc": 450,
      "resetlocation": 451,
      "resetlocations": 452,
      "refreshloc": 453,
      "resetprocgen": 454,
      "resetwp": 455,
      "resetwaypoint": 456,
      "resetwaypoints": 457,
      "build": 458,
      "b": 459,
      "overseer": 460,
      "gm": 461,
      "godmode": 462,
      "abil": 463,
      "crewxp": 464,
      "xp": 465,
      "allxp": 466,
      "xpall": 467,
      "xpcosts": 468,
      "xpcost": 469,
      "testskillcost": 470,
      "allc": 471,
      "allclass": 472,
      "gp": 473,
      "fl": 474,
      "tfl": 475,
      "tm": 476,
      "tt": 477,
      "tdm": 478,
      "tq": 479,
      "tc": 480,
      "tcui": 481,
      "tw": 482,
      "realtime": 483,
      "hideparty": 484,
      "hidep": 485,
      "mpos": 486,
      "rankstyle": 487,
      "clearjournal": 488,
      "clearj": 489,
      "filljournal": 490,
      "fillj": 491,
      "dm": 492,
      "debug": 493,
      "debugMessage": 494,
      "errors": 495,
      "resize": 496,
      "setBPC": 497,
      "setBP": 498,
      "time": 499,
      "wind": 500,
      "weather": 501,
      "resetachievements": 502,
      "formulas": 503,
      "markTrainerLocDone": 504,
      "markDojoLocDone": 505,
      "createTreasureMap": 506,
      "tMapTest": 507,
      "addTreasuresToZone": 508,
      "setupPartyFromGVars": 509,
      "removeTempPartyActors": 510,
      "removeExcessLandingPartyActors": 511,
      "replaceTriggerWithZoneSeries": 512,
      "location_tryUnlockItems": 513,
      "getItemsFromZone": 514,
      "resetFleetAI": 515,
      "adjustFleetAlliegances": 516,
      "openJournal": 517,
      "openJournal_interactive": 518,
      "closeJournal": 519,
      "addJournalGoal": 520,
      "completeJournalGoal": 521,
      "learnJournalEntry": 522,
      "moveJournal": 523,
      "setTerrainType_spriteOffsetMult": 524,
      "setTerrainType_spriteOffsetModulo": 525,
      "setTerrainTypes_spriteOffsetModulo": 526,
      "testzones": 527,
      "gc": 528,
      "listfx": 529,
      "listav": 530,
      "loadItOnUpYo": 531,
      "uploadmod": 532,
      "getmod": 533,
      "editmod": 534,
      "editmodtags": 535,
      "loadModPageInBrowser": 536,
      "setMainMenuUIVisible": 537,
      "howmany": 538,
      "howmanyWorld": 539,
      "discoverFog": 540,
      "setFog": 541,
      "resetAllTileReactTimers": 542,
      "changePlayerActor": 543,
      "stopCombatAIActing": 544,
      "startCombatAIActing": 545,
      "relocateActors": 546,
      "relocateActors_point": 547,
      "task_gvar": 548,
      "investigator_nearestLoc": 549,
      "investigator_tradespecial": 550,
      "investigator_slainenemy": 551,
      "investigator_fleetpos": 552,
      "investigator_setupportselect": 553,
      "setupLocationAsPlayerPort": 554,
      "addIconToCurrentLocation": 555,
      "placeActorFromBoardedShip": 556,
      "setPartyActorAsVendor": 557,
      "readdVendorToParty": 558,
      "giveMathXPToActorWithDialogNodeID": 559,
      "askForNewPortName": 560,
      "setupCafeFoodDialogOptionsWealth100": 561,
      "changeCafeFood": 562,
      "convertPlayerPortsToFaction": 563,
      "addLocationUnlockable": 564,
      "setGlobalVarToActorProperty": 565,
      "UIPartInputCommand": 566,
      "maximizeWindowSet": 567,
      "maximizeWindowIfTrue": 568,
      "changeScreenResolution2": 569,
      "test": 570,
      "test2": 571
    },
    "Action.specialProperty": {
      "requiresCasting": 4,
      "requiresCharging": 5,
      "cancelChargingOnMove": 6,
      "slowMovement": 8,
      "fastMovement": 9,
      "instantMovement": 99,
      "moveCasterTowardTarget": 10,
      "swapCasterWithTarget": 11,
      "swapCasterWithTarget_delay": 111,
      "moveCasterNextToTarget": 12,
      "moveCasterToTarget": 13,
      "walkCasterToTarget": 14,
      "swapTargetWithTarget": 15,
      "moveCasterPastTarget": 16,
      "moveCasterPastTargetOrTowards": 166,
      "redoMovementAnalysis": 1000,
      "swapTargetWithTarget_movement": 155,
      "casterTurnAround": 176,
      "onlyAffectFirstTarget": 199,
      "useFirstTargetToSecondTargetAsOrigin": 1999,
      "requiresAmmo": 22,
      "throwWeapon": 24,
      "usableEvenWhenCantAct": 28,
      "usableEvenWhenReacting": 29,
      "usableEvenWhenYourTurn": 30,
      "usableEvenUnderZoneActRestrictions": 301,
      "cantUseInTravel": 31,
      "cantUseInCombat": 32,
      "cantUseInActionMode": 322,
      "autocastInTravel": 33,
      "startBattleOnCooldown": 34,
      "dontLookAtTarget": 48,
      "treatOriginRotAsDirectionFromCasterToTarget": 49,
      "lookAtAttacker": 50,
      "lookAwayFromAttacker": 51,
      "lookAtAttackerIfWithin1": 501,
      "attractEnemyAttentionInCombat": 53,
      "hideOnTurnOrder": 60,
      "limitRemoteBombsTo5InTravelMode": 70,
      "removeCaster": 80,
      "removeCaster_XP": 81,
      "usableWithoutACaster": 90,
      "cantUseWithoutCrew": 91,
      "moveEvenWhenNotExecuteAfterCast": 125,
      "doesNotCancelOtherSpells": 145,
      "doesNotConsumeCombatAction": 1555,
      "endCombatTurn": 156,
      "dontDelayOtherActions": 168,
      "canReactMultipleTimesPerTurn": 170,
      "ignoreItemToUse": 171,
      "hideEvaluateWindow": 177,
      "showConfirmOptionAlways": 178,
      "doNotShowConfirmOption": 179,
      "applyWeaponBuffsTwice": 190,
      "doNotApplyActionUsedToItemUsed": 191,
      "repositionIfCasterIsPushed": 192
    },
    "TerrainType.SpriteType": {
      "none": -1,
      "single": 0,
      "animated2": 1,
      "animated4": 2,
      "animated8": 228,
      "animated12": 229,
      "animated12_irregular": 2229,
      "animated12_windBased": 2299,
      "animated12_windBased_irregular": 22999,
      "wallSet48": 3,
      "wallSet48_noScaleY_96down": 301,
      "wallSet48_random2": 302,
      "wallSet16": 4,
      "wallSet16_random2": 402,
      "wallSet20": 5,
      "wallSet3": 6,
      "wallSet3NS": 7,
      "ledgeSet_North": 30,
      "ledgeSet_South": 31,
      "ledgeSet_East": 32,
      "ledgeSet_West": 33,
      "slopeBasedWallSet9_North": 8,
      "slopeBasedWallSet9_South": 9,
      "slopeBasedWallSet9_East": 10,
      "slopeBasedWallSet9_West": 11,
      "singleRandom2": 12,
      "singleRandom3": 13,
      "singleRandom4": 14,
      "singleRandom5": 15,
      "singleRandom8": 155,
      "singleRandom16": 16,
      "animated2Slow": 24,
      "animated4Slow": 25,
      "animated8Slow": 26,
      "animated16Slow": 27,
      "animated8Med": 266,
      "picture": 36,
      "picture2x2": 37,
      "picture2x2_animated8": 38,
      "picture3x3": 39
    },
    "WeatherType": {
      "none": 0,
      "rain": 1,
      "storm": 2,
      "snow": 3,
      "gale": 4,
      "krill": 15
    },
    "ItemType.ItemCategory": {
      "thing": 0,
      "consumable": 1,
      "weapon": 2,
      "armor": 3,
      "accessory": 4,
      "tool": 6,
      "other": 7,
      "natural": 8,
      "furnishing": 9,
      "building": 13,
      "mech": 10,
      "hazard": 11,
      "plant": 12,
      "overworld": 14,
      "hide": 99,
      "hidden": 99
    },
    "ItemType.specialProperty": {
      "none": 0,
      "shipWeapon": 33332,
      "cargo": 33333,
      "tradeGood": 33334,
      "foodPrice": 33335,
      "location": 33340,
      "grove": 33341,
      "monsterden": 33342,
      "grove_guaranteed": 33343,
      "waypoint": 33350,
      "waypointConnector": 33351,
      "showOnMinimap": 33300,
      "playerPickup": 1,
      "animated": 2,
      "animatedFast": 2221,
      "animatedPauseOnFrame1and3": 2223,
      "animated2": 2222,
      "animated2Fast": 22222,
      "animatedSlow": 222,
      "animated2Slow": 222222,
      "animated8": 2228,
      "animated8Med": 22288,
      "animated8Fast": 22289,
      "pushable": 3,
      "pushableXOnly": 3991,
      "pushableYOnly": 3992,
      "big": 4,
      "huge": 5,
      "consumeOnUse": 7,
      "canAssignSpecialTC": 8,
      "autoAssignSpecialTC": 882,
      "needsSpecialTCtoReact": 88,
      "dontChangeSpecialTCOnPush": 881,
      "reactsToPressure": 9,
      "cannotBePickedUp": 10,
      "cannotUseInContainer": 11,
      "dontWarnForUseInContainer": 111,
      "applyAVEffectsToTile": 11111,
      "twoHanded": 12,
      "unbreakable": 122,
      "cannotEverBePushed": 13,
      "drawSpecialTC": 15,
      "drawSpecialTCTopLayer": 16,
      "adjustSpriteYUp1": 1096,
      "adjustSpriteY1": 1097,
      "adjustSpriteYUp2": 1098,
      "adjustSpriteY2": 1099,
      "adjustSpriteYUp4": 10984,
      "adjustSpriteY4": 10994,
      "adjustSpriteYUp8": 1100,
      "adjustSpriteY8": 1101,
      "adjustSpriteYUp16": 1102,
      "adjustSpriteY16": 1103,
      "adjustSpriteYUp32": 1104,
      "adjustSpriteY32": 1105,
      "adjustSpriteX2": 1106,
      "adjustSpriteXNeg2": 1107,
      "adjustSpriteX4": 1108,
      "adjustSpriteXNeg4": 1109,
      "adjustSpriteX8": 1110,
      "adjustSpriteXNeg8": 1111,
      "sprite2xHeight": 20,
      "sprite3xHeight": 200,
      "sprite4xHeight": 2000,
      "sprite2xWidth": 21,
      "elementUsableForRestrictedAoEs": 22,
      "preventTileReactions": 23,
      "moveCostOverride_2": 24,
      "moveCostOverride_3": 25,
      "overrideTerrainCollisions": 26,
      "overrideMostCollisions": 2206,
      "pushOnlyCaresAboutLoE": 2207,
      "inheritTerrainPalettes": 27,
      "inheritTerrainPaletteR": 270,
      "inheritTerrainPaletteG": 271,
      "inheritTerrainPaletteB": 272,
      "canHangOnWalls": 6,
      "canBeInsideWalls": 28,
      "canFloatOnWater": 29,
      "canOnlyBeOnWater": 2900,
      "canBePlacedOnBlockedEarthTiles": 600,
      "alwaysBuried": 30,
      "invisible": 31,
      "itemsIgnoreBlockWalking": 33,
      "itemsOnSameTileAreRaised": 34,
      "ignoreBeingRaised": 35,
      "ignoreBeingRaised_offsetOnly": 356,
      "ignoreHeight": 355,
      "actorsOnSameTileAreRaised": 36,
      "canBeDroppedInOverworld": 37,
      "canOnlyBeDroppedInOverworld": 3776,
      "unburyWhenLookedAt": 3777,
      "alwaysBelowOtherItems": 38,
      "bottomPriorityItemClickSearchOrder": 3838,
      "canAlwaysFitInTile": 39,
      "canAlwaysFitInTileWhenSpawned": 40,
      "canAlwaysFitInTile_build": 41,
      "ignoreDarkness": 43,
      "supertransparent": 443,
      "verytransparent": 444,
      "transparent": 44,
      "semitransparent": 45,
      "quantityIncreasesPaletteRZoneMisc": 1011,
      "quantityChangesSprite_upTo2": 46,
      "quantityChangesSprite_upTo3": 47,
      "quantityChangesSprite_upTo4": 48,
      "quantityChangesSprite_upTo5": 49,
      "quantityChangesSprite_upTo6": 50,
      "quantityChangesSprite": 51,
      "container_drawRandomItem": 54,
      "disappearFromCorpse": 55,
      "shopContainer": 56,
      "infiniteStockContainer": 57,
      "priorityContainer": 58,
      "lockedContainer": 59,
      "container": 60,
      "container2x2": 61,
      "container2x3": 62,
      "container4x4": 64,
      "container5x5": 65,
      "container8x8": 66,
      "containerWood": 70,
      "containerSkull": 71,
      "containerMetal": 72,
      "defaultContainsWoodEquipment": 73,
      "defaultContainsIronEquipment": 730,
      "defaultContainsSteelEquipment": 731,
      "defaultContainsMythrilEquipment": 732,
      "defaultContainsToolEquipment": 733,
      "stackCannotBeSplit": 80,
      "defaultStack_2": 81,
      "defaultStack_x2": 82,
      "defaultStack_x3": 83,
      "defaultStack_x10": 84,
      "defaultStack_x1024Rand": 85,
      "animateEvery100Frames": 100,
      "emitParticleEvery100Frames": 102,
      "hideTimer": 119,
      "timer": 120,
      "timer_advanceOnScreenOnly": 121,
      "hiddenFromBuildMode": 130101,
      "noTooltip": 130,
      "noTooltips": 130,
      "noTooltipIcons": 131,
      "autoEquipOnPickup": 132,
      "equipInAnySlot": 133,
      "currency": 134,
      "cannotBeTraded": 135,
      "cannotBeBuried": 136,
      "climbAnim": 145,
      "studyTool": 160,
      "repairTool": 161,
      "cannotBeSheathed": 162,
      "rotate90WhenSheathed": 1620,
      "rotate180WhenSheathed": 1621,
      "rotate270WhenSheathed": 1622,
      "cannotBeRotated": 1623,
      "rotateWhenUsed": 164,
      "canUseWithoutConsumingAction": 1655,
      "addCastersRotationOnSpawn": 165,
      "reactionsDontPreventMoveUndo": 167,
      "canReactWhileMoving": 168,
      "delayBetweenReactions": 169,
      "canReactIndefinitely": 170,
      "dontCloneReactions": 171,
      "dontIncrementTimerInInventory": 172,
      "raiseTileDepth1050": 180,
      "raiseTileDepth2050": 181,
      "raiseItemsDepth900": 18002,
      "raiseItemsDepth1000": 18001,
      "raiseItemsDepth1050": 1801,
      "raiseActorsDepth200": 18022,
      "raiseActorsDepth1000": 18021,
      "raiseActorsDepth1050": 1802,
      "noPlayerPlacedItems": 185,
      "cantGrabItemsFromThisTile": 186,
      "roof": 190,
      "roofFaded": 191,
      "invisibleUnderRoofs": 1911,
      "blackenOtherTiles": 192,
      "notBlackened": 193,
      "drawLightOnTopOfRoofs": 194,
      "cannotTarget": 1900,
      "cannotTargetInPeacefulZones": 1901,
      "cannotAct": 1902,
      "cannotActInPeacefulZones": 1903,
      "noTileHitbox": 1955,
      "fullTileHitbox": 195,
      "fullTileRoof": 196,
      "replaceTerrainWithDefault1PercentChance": 210,
      "replaceTerrainWithDefault1PercentChance_GroupA": 212,
      "removeItems1PercentChance": 220,
      "removeItemsIfNoOtherItemsRemoved": 224,
      "removeItems1PercentChance_B": 226,
      "removeItemsIfNoOtherItemsRemoved_B": 227,
      "replaceWith_toMake_list": 230,
      "replaceWith_globalVarMatch": 229,
      "replaceWith_assign_globalVar": 23019,
      "randomRotateWhenPlaced": 231,
      "randomFlipWhenPlaced": 232,
      "randomOffsetYUp4WhenPlaced": 2321,
      "set0RotWhenPlaced": 991,
      "canRot45deg": 992,
      "reactionDoesntApplyItemRot": 994,
      "slideWhenPushed": 233,
      "slideWhenPushedMax4": 234,
      "oneClickToUse": 240,
      "canUseInAnyZone": 241,
      "shopTile": 245,
      "wiggleWhenMoved": 255,
      "anim_bobUpAndDown": 259,
      "anim_bobUpAndDown_slow": 260,
      "anim_bobUpAndDown_slow_small": 2601,
      "anim_scaleUpAndDown": 261,
      "anim_scaleUpAndDown_slow": 262,
      "anim_scaleUpAndDown_slow_small": 263,
      "anim_bobLeftAndRight": 264,
      "anim_bobLeftAndRight_slow": 2640,
      "anim_bobLeftAndRight_slow_small": 2641,
      "convertIntoCashAtEnd": 265,
      "setGlobalVarWhenConverted": 266,
      "sellForFullValue": 267,
      "cantEndCombat": 2700,
      "openEnhanceUI": 275,
      "enhanceSlots_0": 280,
      "enhanceSlots_1": 281,
      "enhanceSlots_2": 282,
      "enhanceSlots_3": 283,
      "enhanceSlots_4": 284,
      "enhanceSlots_5": 2841,
      "enhanceSlots_6": 2842,
      "enhanceSlots_7": 2843,
      "enhanceSlots_8": 2844,
      "enhanceDoesntAlterPalettes": 285,
      "blockLoE_exceptFromN": 333,
      "blockLoE_exceptFromS": 334,
      "blockLoE_exceptFromE": 335,
      "blockLoE_exceptFromW": 336,
      "blockJumpingRot": 3302,
      "blockJumping_N": 3303,
      "blockJumping_S": 3304,
      "blockJumping_E": 3305,
      "blockJumping_W": 3306,
      "slopeRot": 3309,
      "slopeN": 3310,
      "slopeS": 3311,
      "slopeE": 3312,
      "slopeW": 3313,
      "attachedToPushable": 353,
      "removeWhenAtZoneEdge": 354,
      "reduceItemGrabRangeWhenStoodUpon": 35619,
      "canAlwaysReachThisTile": 357,
      "rollingPin_drawLower": 358,
      "rollingPin_drawY3Lower": 3580,
      "rollingPin_drawSplit": 3581,
      "rollingPin_drawFlat": 359,
      "rollingPin_scaleHalf": 360,
      "rollingPin_scaleMore": 361,
      "rollingPin_dontApplyDepthMod": 3611,
      "rollingPin_scaleDepthMod": 36111,
      "rollingPin_squishOnHorizon": 3612,
      "waterFXTile": 362,
      "windBeacon": 366,
      "weatherBeacon": 368,
      "monsterBeacon": 370,
      "lakeMarker": 372,
      "forestOverworldItem": 39999,
      "travel_point0": 376,
      "travel_point1": 377,
      "travel_point2": 378,
      "travel_point3": 379,
      "travel_point4": 380,
      "travel_point5": 381,
      "travel_point6": 382,
      "travel_point7": 383,
      "travel_point8": 384,
      "travel_point9": 385,
      "travel_point0B": 476,
      "travel_point1B": 477,
      "travel_point2B": 478,
      "travel_point3B": 479,
      "travel_point4B": 480,
      "travel_point5B": 481,
      "travel_point6B": 482,
      "travel_point7B": 483,
      "travel_point8B": 484,
      "travel_point9B": 485,
      "travel_point0C": 576,
      "travel_point1C": 577,
      "travel_point2C": 578,
      "travel_point3C": 579,
      "travel_point4C": 580,
      "travel_point5C": 581,
      "travel_point6C": 582,
      "travel_point7C": 583,
      "travel_point8C": 584,
      "travel_point9C": 585,
      "travel_point0D": 676,
      "travel_point1D": 677,
      "travel_point2D": 678,
      "travel_point3D": 679,
      "travel_point4D": 680,
      "travel_point5D": 681,
      "travel_point6D": 682,
      "travel_point7D": 683,
      "travel_point8D": 684,
      "travel_point9D": 685,
      "spawnpoint": 777
    },
    "AoEShapeType": {
      "plusShape": 0,
      "walkpathShape": 1,
      "walkpathShape_straightLinesPlus2": 111,
      "lineShape": 2,
      "wideLineShape": 3,
      "player": 5,
      "playerParty": 6,
      "allButPlayerParty": 66,
      "allActors": 7,
      "allTiles": 8,
      "allActors_nonIncapped": 17,
      "useWeaponAoE": 10,
      "useWeaponAVAoE": 11,
      "diagonalX": 25
    },
    "JournalEntry.JournalCategory": {
      "notes": 0,
      "help": 1,
      "creature": 2,
      "item": 3,
      "actorClass": 4,
      "equipment": 5,
      "artifact": 6,
      "other": 8
    },
    "Element": {
      "any": -2,
      "none": -1,
      "physical": 0,
      "magic": 1,
      "melee": 2,
      "ranged": 3,
      "use": 10,
      "slash": 11,
      "smash": 12,
      "heavySlash": 13,
      "heavySmash": 14,
      "stab": 1444,
      "heavyStab": 1445,
      "explode": 15,
      "mech": 16,
      "mechanical": 16,
      "mech2": 17,
      "mechanical2": 17,
      "pickaxe": 19,
      "dig": 20,
      "digDown": 21,
      "growth": 22,
      "wither": 23,
      "bury": 24,
      "focus": 25,
      "prayer": 26,
      "fire": 30,
      "heat": 303,
      "ice": 31,
      "water": 32,
      "deepwater": 322,
      "abyss": 3222,
      "elec": 33,
      "lightning": 33,
      "fakeElec": 333,
      "earth": 34,
      "wind": 35,
      "life": 36,
      "ruin": 37,
      "acid": 39,
      "poison": 40,
      "oil": 41,
      "HPbased": 44,
      "breakItem": 45,
      "shatter": 46,
      "weapon": 49,
      "sword": 50,
      "dagger": 51,
      "fist": 52,
      "axe": 53,
      "hammer": 54,
      "flail": 55,
      "spear": 56,
      "bow": 57,
      "aim": 58,
      "shield": 59,
      "whip": 60,
      "cannon": 61,
      "javelin": 62,
      "axe_throw": 63,
      "dart": 65,
      "kindle": 301,
      "ruinTouch": 80,
      "dispel": 81,
      "bonemeld": 82,
      "antiMachine": 83,
      "antimachine": 83,
      "antiUndead": 84,
      "mechanistAbil": 85,
      "weaponAugment": 86,
      "gateCannon": 867,
      "pressurePlateDown": 90,
      "pressurePlateUp": 91,
      "pressureMove": 92,
      "pressureMoveAcross": 93,
      "pressureJumpAcross": 934,
      "pressureMoveTo": 89,
      "elementwalker": 900,
      "elementwalker_status": 901,
      "itemEquipped": 931,
      "itemCombine": 94,
      "itemCombined": 94,
      "actionUsed": 95,
      "timerUp": 96,
      "weaponBuff": 97,
      "appliedWeaponBuffs": 971,
      "combatStart": 98,
      "combatEnd": 99,
      "combatLost": 990,
      "combatWon": 991,
      "gameOver": 992,
      "tileReacted": 100,
      "itemReacted_timerUp": 1000,
      "actorFall": 101,
      "actionTaken": 1022,
      "noActionTaken": 102,
      "noMoveTaken": 103,
      "startTurn": 1043,
      "endTurn": 1033,
      "moveAbilUsed": 1030,
      "usedMeleeWeaponAtk": 1034,
      "daytime": 10344,
      "nighttime": 1035,
      "nightime": 1035,
      "newDay": 1036,
      "incapacitated": 104,
      "incapped": 104,
      "enemyKOd": 105,
      "dodged": 1055,
      "blocked": 1056,
      "reloading": 106,
      "reload": 107,
      "repair": 109,
      "railway": 111,
      "spreadRope": 114,
      "removeRope": 115,
      "spreadChain": 116,
      "removeChain": 117,
      "unarmed": 118,
      "BreakerWpn": 119,
      "shiftcloakWpn": 120,
      "punchDaggerWpn": 121,
      "hammerDaggerWpn": 1211,
      "shieldShotWpn": 1212,
      "whipFlailWpn": 1213,
      "catchFish": 122,
      "fistWpn": 123,
      "closeContainer": 126,
      "removeDecay": 130,
      "cutsc_destroy": 140,
      "windAnimate": 141,
      "replaceCapsule": 142,
      "stairs": 145,
      "itemPushed": 150,
      "burst1": 160,
      "burstSpread1": 161,
      "burst2": 162,
      "burstSpread2": 163,
      "burst3": 164,
      "burstSpread3": 165,
      "drainWater": 167,
      "odduleDeath": 175,
      "blockDestroyed": 188,
      "vines_wither": 555,
      "vines_growth": 556,
      "burnStatus": 664,
      "decaying": 665,
      "defiler": 666,
      "matched": 677,
      "matchedSelf": 678,
      "notInCastleZone": 700,
      "inCastleZone": 701,
      "nearKeyPedestal": 702,
      "openGates": 705,
      "closeGates": 706,
      "gameLoaded": 777,
      "leavingZone": 778,
      "removeShadow": 711,
      "somethingHappened": 712,
      "monsterBeaconUsed": 1133,
      "everswarm": 716,
      "batZWing": 717,
      "pillImmune": 718,
      "slayAspect": 719,
      "transform": 721,
      "spawnFireWhirl": 720,
      "pushDamage": 1134,
      "boardingEnd": 1135
    },
    "LightMapSize": {
      "Full": 1,
      "Fourth": 2,
      "Eighth": 4
    },
    "BlendTechnique": {
      "Add": 1,
      "Multiply": 2
    },
    "BlurTechnique": {
      "Horizontal": 1,
      "Vertical": 2
    },
    "AoEPreset": {
      "detect": 0,
      "adjacentAndSelf": 1,
      "adjacentAndSelf+1": 2,
      "adjacentAndSelf+2": 3,
      "adjacentAndSelf+3": 4,
      "adjacent": 5,
      "adjacent+1": 6,
      "adjacent+2": 7,
      "adjacent+3": 8,
      "oneTile": 9,
      "party": 10,
      "allParty": 11,
      "allActors": 12,
      "allAllies": 13,
      "allEnemies": 14,
      "walk": 15,
      "oneTileWalk": 16,
      "oneTileWalk_selectActors": 17,
      "boat": 18,
      "fill": 19,
      "deepwater_search": 20,
      "water_search": 21,
      "land_search": 22
    }
  }
}